__turbopack_context__.v({
  "rating": "UserRating-module-scss-module__q6NhSq__rating",
  "score": "UserRating-module-scss-module__q6NhSq__score",
});
